import type { AppsSearchFiltersDto } from "app/pages/sales-intelligence/domain/apps/types/filter-values";
import type {
    IContactDetailsFilterDto,
    IContactsPerCompanyFilterDto,
    IEmployeeLocationFilterDto,
} from "app/pages/sales-intelligence/domain/contacts/types/filter-values";
import type {
    CrmFiltersList,
    CrmFiltersModel,
} from "app/pages/sales-intelligence/domain/crm-integration/types/custom-filter-values";
import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import type { ILeadsSearchLeadsFiltersDto } from "app/pages/sales-intelligence/domain/leads/types/filter-values";
import type {
    SignalsGroupedByTypeKey,
    SignalsDTO,
} from "app/pages/sales-intelligence/domain/signals/types/signal-collection";
import type { IContactsEmployeeProfiles } from "app/pages/sales-intelligence/modules/contacts-search-filters/types/dto";
import type { Profile } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/common";

/** @deprecated Import from "app/pages/sales-intelligence/domain/leads/types/filter-values" instead */
export type {
    IAdSpendChannelsFilterDto,
    IAdSpendVolumeFilterDto,
    ICompanyHeadquarterFilterDto,
    IDisplayAdsFormatFilterDto,
    IEngagementFilterDto,
    IIncomingTrafficFilterDto,
    IInternationalVisitsFilterDto,
    IMarketingChannelsFilterDto,
} from "app/pages/sales-intelligence/domain/leads/types/filter-values";

// TODO move to domain/contacts
interface ILeadsSearchContactsFiltersDto {
    useContactFiltersForCompanies: boolean;
    searchText: string;
    employeeLocation: IEmployeeLocationFilterDto;
    contactDetails: IContactDetailsFilterDto;
    contactsPerCompanyFilter: IContactsPerCompanyFilterDto;

    profileIds: readonly string[];
    profiles: readonly Profile[];
    employeeProfiles: IContactsEmployeeProfiles;

    companyDomains: readonly string[];
}

export type ILeadsSearchFiltersDto = {
    readonly contactsFilters: Partial<ILeadsSearchContactsFiltersDto>;
    readonly leadsFilters: Partial<ILeadsSearchLeadsFiltersDto>;
    readonly signalsFilters: SignalsDTO;
    readonly appsFilters: Partial<AppsSearchFiltersDto>;
    readonly salesforceCustomFilters?: CrmFiltersModel;
};

type LeadsSearchFiltersList = ILeadsSearchContactsFiltersDto &
    ILeadsSearchLeadsFiltersDto &
    Omit<AppsSearchFiltersDto, "searchText"> &
    SignalsGroupedByTypeKey &
    CrmFiltersList;

export type LeadsSearchAllFiltersTypes = Omit<LeadsSearchFiltersList, "searchText">;

export type LeadsSearchFilterKey = keyof LeadsSearchAllFiltersTypes;

export type LeadsSearchFilterValue = LeadsSearchAllFiltersTypes[LeadsSearchFilterKey];

export type LeadsSearchFilterApiCategory = keyof ILeadsSearchFiltersDto;

export const providerToApiCategory: Partial<Record<CrmIntegrationProvider, LeadsSearchFilterApiCategory>> = {
    salesforce: "salesforceCustomFilters",
} as const;
